import { useUserStore } from '@/stores/user';
import { isDateAfterOrEqual, nowInstant, toZonedDateTime } from '@/utils/temporalUtils';
import { LegalEntityEnum } from '@onrunning/backstage-models';
import { storeToRefs } from 'pinia';
import { DateTimeZone } from '../types/date-timezone.enum';

const BRAZIL_REORDER_ENABLE_DATE = '2026-03-02';

export const isBrazilReOrderEnabled = (): boolean => {
  // Current calendar date in Brazil
  const nowInBrazil = toZonedDateTime(nowInstant(), DateTimeZone.America_Sao_Paulo).toPlainDate();

  return isDateAfterOrEqual(nowInBrazil, BRAZIL_REORDER_ENABLE_DATE);
};

export function useHelper() {
  const { selectedAccount } = storeToRefs(useUserStore());

  const isReOrderAllowedForONBR = (): boolean => {
    if (selectedAccount.value?.legalEntity !== LegalEntityEnum.ON_BR) {
      return true;
    }

    return isBrazilReOrderEnabled();
  };

  return {
    isReOrderAllowedForONBR,
  };
}
